import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GridLoaderComponent } from './gridloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [GridLoaderComponent],
    exports: [GridLoaderComponent],
})
export class GridLoaderModule {}
